import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

export interface SessionWarningSnackbarData {
  countdownLabel: string;
}

@Component({
  selector: 'app-session-warning-snackbar',
  standalone: true,
  imports: [MatButtonModule, TranslateModule],
  templateUrl: './session-warning-snackbar.component.html',
  styleUrl: './session-warning-snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionWarningSnackbarComponent {
  protected readonly data = inject<SessionWarningSnackbarData>(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef = inject(MatSnackBarRef<SessionWarningSnackbarComponent>);
  protected countdownLabel = this.data.countdownLabel;

  protected staySignedIn(): void {
    this.snackBarRef.dismissWithAction();
  }

  public setCountdownLabel(countdownLabel: string): void {
    this.countdownLabel = countdownLabel;
  }
}
